<template>
  <div class="edit-module-index-main" :class="{'not-scroll-padding': currentInfo.type === 'profile'}">
    <!--
      basicInfo 基本信息
      edus      教育
      works     工作
      orgs      社团和组织经历
      custom    待定
      other     技能/证书及其他
     -->
    <!-- 基本信息 -->
    <basic-info ref="profileForm" v-if="currentInfo.type === 'profile'" :data="{type: ''}" @close="$emit('close')"/>
    <!-- 教育 工作 社团组织-->
    <base-module-form ref="baseModuleForm" v-else-if="showBaseForm" />
    <opus-module-form ref="opusForm" v-else-if="currentInfo.type === 'opus'" />
    <custom-module-form ref="customModuleForm" v-else-if="currentInfo.type !== 'extras'" />
    <other ref="otherForm" v-else @close="$emit('close')" @update-title="value => {$emit('update-title', value)}"/>
  </div>
</template>
<script>
	import basicInfo from './basicInfo'
	import baseModuleForm from './base-module-form'
	import customModuleForm from './custom-module-form'
	import opusModuleForm from './opus-module-form'
	import other from './other'
	import intention from './intention'
	import editorPlaceholder from '@/assets/json/editor-placeholder'
	import { mapMutations, mapState } from 'vuex'

	export default {
		name: 'EditModuleIndex',
		components: {
			basicInfo,
			baseModuleForm,
			customModuleForm,
			other,
      intention,
      opusModuleForm
		},
		props: {
			data: Object
		},
		computed: {
			...mapState('cvsEditor', [ 'editModuleData' ]),
			...mapState('cvs', [ 'cvs', 'cv', 'cvPages', 'downloadCv', 'editCheckData', 'editorCvToken', 'autoOnePage' ]),
			...mapState('editor', [ 'currentInfo' ]),
			showBaseForm () {
				let { type } = this.currentInfo
				return type === 'works' || type === 'orgs' || type === 'edus'
			}
		},
		methods: {
			saveModuleData () {
				let { type } = this.currentInfo
				if (type === 'profile') {
					this.$refs.profileForm.debounceSave()
				} else if (this.showBaseForm) {
          this.$refs.baseModuleForm.debounceSave()
        } else if (type === 'opus'){
          this.$refs.opusForm.debounceSave()
				} else if (type !== 'extras') {
					this.$refs.customModuleForm.debounceSave()
				} else {
					this.$refs.otherForm.debounceSave()
				}
			}
		}
	}
</script>
<style lang="scss">
  .edit-module-index-main {
    @import 'cvsEditModule';
    width: 100%;
    max-height: 100%;
    background: #fff;
    overflow-y: auto;
    padding-top: 58px;
    border-radius: 4px;
    box-sizing: border-box;
    /*padding-bottom: 68px;*/
    .el-form-item {
      margin: 0;
    }
    .edit-editor-item {
      position: relative;
    }
    .edit-item-now {
      // width: calc(100% - 32px);
      border-radius: 4px;
      height: calc(100% - 4px);
      position: absolute;
      left: 46px;
      right: 1px;
      top: 2px;
      background: #fff;
      z-index: 1;
      // opacity: .5;
      pointer-events: none;
      line-height: 38px;
      padding-left: 3%;
      color: #606266;
    }
    // select
    .el-select .el-input {
      .el-select__caret {
        line-height: 36px;
      }
    }
  }
  .not-scroll-padding {
    padding-bottom: 68px;
  }
  .el-picker-panel__shortcut,
  .el-month-table td .cell {
    color: #404040;
  }
  .el-month-table td .cell:hover {
    color: #409EFF;
  }
  .el-date-picker.has-sidebar {
    width: 322px;
  }
  .el-picker-panel [slot=sidebar], .el-picker-panel__sidebar {
    bottom: 2px;
    right: 0;
    left: -1px;
    top: auto;
    width: calc(100% + 2px);
    display: flex;
    justify-content: center;
    padding: 6px 30px;
    transform: translateY(100%);
    // background: red;
    border: 1px solid #EBEEF5;
    z-index: 9;
    margin-top: -2px;
    border-radius: 0 0 4px 4px;
    button {
      width: 50px;
      // border: 1px solid #EBEEF5;
      font-size: 12px;
      border-radius: 2px;
    }
  }
  .el-picker-panel [slot=sidebar] + .el-picker-panel__body, .el-picker-panel__sidebar + .el-picker-panel__body {
    margin: 0;
  }

  .edit-module-index-main .edit-item-now.ageAndBirth {
    margin-left: -20px;
    line-height: 35px;
  }
</style>
